import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import DefaultPtBr from './translations/pt_br/default.json';

// you can use the BabelEdit app to maitain these files
const resources = {
  pt_br: { translation: DefaultPtBr }
};

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV !== 'production',
    resources,
    lng: 'pt_br',

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;